import API from "@/api/API";


export default class PaymentsCalculationsAPI extends API {
  constructor(parameters = {}) {
    super("/PaymentsCalculations", parameters);
  }

  calculatePayments(contractId, componentId, versionId) {
    let url = `${this.endpoint}/Payments/${contractId}/${componentId}`
    if (versionId)
      url += `?versionId=${versionId}`;

    return this.submit("get", url);
  }

  calculateTotalPayments(data, versionId) {
     if (versionId) {
      return this.submit("post", `${this.endpoint}/PaymentsTotalChart?versionId=${versionId}`, data);
    } else {
      return this.submit("post", `${this.endpoint}/PaymentsTotalChart`, data);
    }
  }

  calculatePaymentsPreview(data) {
    return this.submit("post", `${this.endpoint}/PaymentsPreview`, data);
  }

  calculateLiabilities(contractId, componentId, versionId) {
    let url = `${this.endpoint}/Liabilities/${contractId}/${componentId}`
    if (versionId)
      url += `?versionId=${versionId}`;

    return this.submit("get", url);
  }

  calculateLiabilitiesPreview(data) {
    return this.submit("post", `${this.endpoint}/LiabilitiesPreview`, data);
  }

  calculateTotalLiabilities(data, versionId) {

    if (versionId) {
      return this.submit("post", `${this.endpoint}/LiabilitiesTotal?versionId=${versionId}`, data);
    } else {
      return this.submit("post", `${this.endpoint}/LiabilitiesTotal`, data);
    }
  }

  calculateLiabilitiesResult(contractId, versionId) {
    if (versionId) {
      return this.submit("post", `${this.endpoint}/LiabilitiesTotals/${contractId}?versionId=${versionId}`);
    } else {
      return this.submit("post", `${this.endpoint}/LiabilitiesTotals/${contractId}`);
    }
  }

  getContractVersions(contractId)
  {
    return this.submit("post", `${this.endpoint}/ContractVersions/${contractId}`);
  }

  calculateLiabilitiesResultPreview(data) {
    return this.submit("post", `${this.endpoint}/LiabilitiesTotalsPreview`, data);
  }

  exportResultOfCalculatePayments(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfCalculatePayments`, data);
  }

  exportResultOfCalculatePaymentsLiabilities(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfCalculateLiabilities`, data);
  }

}
